import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { CommentDto } from '@zoxo/shared';

import { api } from '../../lib/api';
import { commentsKey, commentsPath, type CommentTarget } from './comment-target';

/**
 * Comments for a target (GET {base}/comments, US-3.1). The 2-level thread is
 * shared by surveys and PD 수첩 articles (V4) — `target` selects the endpoint and
 * cache key. Suspense read; the route's Error Boundary covers failures. Public
 * endpoint, so it loads for anonymous viewers too.
 */
export function commentsQuery(target: CommentTarget) {
  return queryOptions({
    queryKey: commentsKey(target),
    queryFn: () => api.get<CommentDto[]>(commentsPath(target)),
  });
}

export function useComments(target: CommentTarget) {
  return useSuspenseQuery(commentsQuery(target));
}
